import React, { Suspense } from "react";
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import Shell from "./layout/Shell";
import Preloader from "./layout/Preloader";
import { ThemeProvider } from "../lib/theme";

const Home = React.lazy(() => import("../pages/Home"));
const Work = React.lazy(() => import("../pages/Work"));
const About = React.lazy(() => import("../pages/About"));

function RouteFallback() {
	return (
		<div className="flex min-h-[70vh] items-center justify-center">
			<div className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.24em] text-content-faint">
				<span className="h-1.5 w-1.5 animate-blink rounded-full bg-accent" />
				Loading
			</div>
		</div>
	);
}

export default function App() {
	return (
		<ThemeProvider>
			<HashRouter>
			<Preloader />
			<Shell>
				<Suspense fallback={<RouteFallback />}>
					<Routes>
						<Route path="/" element={<Home />} />
						<Route path="/work" element={<Work />} />
						<Route path="/about" element={<About />} />
						{/* 예전 링크 호환 */}
						<Route path="/projects" element={<Navigate to="/work" replace />} />
						<Route path="*" element={<Navigate to="/" replace />} />
					</Routes>
				</Suspense>
			</Shell>
			</HashRouter>
		</ThemeProvider>
	);
}
